import { GoogleOAuthProvider } from '@react-oauth/google';
import { createAuthProvider } from './context';
import { webStorage } from './storage';
import { buildEnvironmentConfig } from '@/config/env';

// Create the base auth provider using environment-aware configuration
const BaseAuthProvider = createAuthProvider({
  apiBaseUrl: buildEnvironmentConfig.apiBaseUrl,
  storage: webStorage,
});

// Wrap the base provider with web-specific OAuth providers
export function AuthProvider({ children }: { children: React.ReactNode }) {
  return (
    <GoogleOAuthProvider clientId={import.meta.env.VITE_GOOGLE_CLIENT_ID || ''}>
      <BaseAuthProvider>
        {children}
      </BaseAuthProvider>
    </GoogleOAuthProvider>
  );
}

// Re-export the useAuth hook and utility functions
export { useAuth } from './context';

// Re-export OAuth functions
export { loginWithGoogle, loginWithMicrosoft, handleGoogleCallback, handleMicrosoftCallback } from './oauth';

// Re-export logout utility
export { performLogout, type LogoutOptions } from './logout'; 